import axios from 'axios';
import * as urls from '../actions/urlTypes';
import {
  UPDATE_GEOGRAPHY_TREE_LOAD,
  GET_INITIAL_GEOGRAPHY_TREE,
  GET_GEOGRAPHY_TREE_LOAD,
  SEARCH_GEOGRAPHY_TREE_LOAD,
  GET_GEOGRAPHY_SMART_SEARCH,
  CLEAR_GEOGRAPHY_SMART_SEARCH,
} from '../actions/actionTypes';

export const updateTreeLoad = node => ({
  type: UPDATE_GEOGRAPHY_TREE_LOAD,
  node,
});

export const getInitialGeographyTree = () => ({
  type: GET_INITIAL_GEOGRAPHY_TREE,
  payload: 0,
});
export const getGeographyTreeLoad = (payload, node) => ({
  type: GET_GEOGRAPHY_TREE_LOAD,
  payload,
  node,
});

export const searchGeographyTree = (payload, nodeID) => ({
  type: SEARCH_GEOGRAPHY_TREE_LOAD,
  payload,
  nodeID,
});

export const getGeographySearch = payload => ({
  type: GET_GEOGRAPHY_SMART_SEARCH,
  payload,
});

export const clearGeographySmartSearchData = () => ({
  type: CLEAR_GEOGRAPHY_SMART_SEARCH,
});

export function handleSearchGeographyTreeLoad(
  token,
  uid,
  accountId,
  productNo,
  node,
) {
  const url = `${
    urls.ROOT_URL
  }/dictionary/geoload/${accountId}/${uid}/${productNo}/${node.nodeId}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => dispatch(getGeographyTreeLoad(response.data, node)))
      .catch(response => console.warn(response.data));
  };
}

export function handleGeographySearch(token, uid, accountId, productNo) {
  const url = `${
    urls.ROOT_URL
  }/dictionary/geosearch/${accountId}/${uid}/${productNo}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => dispatch(getGeographySearch(response.data)))
      .catch(response => console.warn(response.data));
  };
}
